import { Property } from '@propertypal/shared/src/types/property';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import Chevron from '../icons/Chevron';
import { LinkText, Text } from '../typography';
import { Container } from './ListingBox.style';

interface Props {
  property: Property;
}

const ListingBox: FunctionComponent<Props> = (props) => {
  const excludeDevelopers = props.property.contacts && props.property.contacts.all.length > 1;

  if (props.property.published) {
    return (
      <Container>
        {props.property.images?.length && (
          <img src={props.property.images[0].url} alt={props.property.displayAddress} />
        )}

        <div>
          <Text>{props.property.displayAddress}</Text>

          <Text mt={5}>
            <Link href={props.property.path} passHref>
              <LinkText>
                View Listing <Chevron size={12} />
              </LinkText>
            </Link>
          </Text>
        </div>
      </Container>
    );
  }

  return (
    <>
      {props.property.contacts?.all.map((contact) => {
        if (excludeDevelopers && contact.developer) {
          return null;
        }

        return (
          <Container key={contact.accountNumber}>
            {contact.logos?.standard && <img src={contact.logos.standard} alt={contact.organisation} />}

            <div>
              <Text>Marketed by</Text>

              <Text fontWeight="bold">{contact.organisation}</Text>

              {contact.landingPageUrl && (
                <Text mt={5}>
                  <Link href={contact.landingPageUrl} passHref>
                    <LinkText>
                      View contact information <Chevron size={12} />
                    </LinkText>
                  </Link>
                </Text>
              )}
            </div>
          </Container>
        );
      })}
    </>
  );
};

export default ListingBox;
